import { BadgeVariant } from '@tallo/design-system';
import { PropertyStatus } from '@tallo/property';

const statusVariants: Record<PropertyStatus, BadgeVariant> = {
  [PropertyStatus.DRAFT]: 'grey',
  [PropertyStatus.LISTED]: 'green',
  [PropertyStatus.READY_FOR_LISTING]: 'violet',
  [PropertyStatus.LISTING_IN_PROGRESS]: 'blue',
  [PropertyStatus.RENTED_OUT]: 'yellow',
  [PropertyStatus.UNLISTED]: 'grey',
  [PropertyStatus.SYNDICATION_ERROR]: 'red',
};

// The status names cut to a word or two, for a chip or a count ("4 rented out")
const statusShortLabels: Record<PropertyStatus, string> = {
  [PropertyStatus.DRAFT]: 'draft',
  [PropertyStatus.READY_FOR_LISTING]: 'ready',
  [PropertyStatus.LISTING_IN_PROGRESS]: 'in progress',
  [PropertyStatus.LISTED]: 'listed',
  [PropertyStatus.UNLISTED]: 'unlisted',
  [PropertyStatus.RENTED_OUT]: 'rented out',
  [PropertyStatus.SYNDICATION_ERROR]: 'sync error',
};

// The order a listing moves through its statuses, which is also the order a landlord scans them in
const statusOrder: Record<PropertyStatus, number> = {
  [PropertyStatus.LISTED]: 1,
  [PropertyStatus.LISTING_IN_PROGRESS]: 2,
  [PropertyStatus.SYNDICATION_ERROR]: 3,
  [PropertyStatus.READY_FOR_LISTING]: 4,
  [PropertyStatus.DRAFT]: 5,
  [PropertyStatus.UNLISTED]: 6,
  [PropertyStatus.RENTED_OUT]: 7,
};

/** The badge colour every status label wears, so a status reads the same on a card, a chip and a count */
export function propertyStatusVariant(status: PropertyStatus): BadgeVariant {
  return statusVariants[status];
}

/** "rented out", "ready" - the status as a count or a chip names it */
export function propertyStatusShortLabel(status: PropertyStatus): string {
  return statusShortLabels[status];
}

/** Listed first, rented out last; a tie keeps the given order */
export function sortByStatus<T extends { status: PropertyStatus }>(properties: T[]): T[] {
  return [...properties].sort((a, b) => statusOrder[a.status] - statusOrder[b.status]);
}
